








import { Component, Vue } from 'vue-property-decorator';
import { biClick } from '@tencent/fit-bi-sdk';

@Component({
  components: {
  },
})

export default class DiscoverMore extends Vue {
  clickMore() {
    biClick('discover-more.btn_click|收藏的优惠探索更多按钮点击');
    this.$router.push({
      path: '/weCoupons/merchantList/class0',
    });
  }
}
